// TODO(migration): Re-implement PWA update prompt without vite-plugin-pwa.
// Original used `virtual:pwa-register/react` from vite-plugin-pwa which is
// not compatible with Bun bundler. Workbox is still in deps; refactor to
// register SW manually via `workbox-window`.
const UpdatePrompt = () => null;

export default UpdatePrompt;
